import { render, staticRenderFns } from "./AlarmBox.vue?vue&type=template&id=eab6bd96&scoped=true"
import script from "./AlarmBox.vue?vue&type=script&lang=js"
export * from "./AlarmBox.vue?vue&type=script&lang=js"
import style0 from "./AlarmBox.vue?vue&type=style&index=0&id=eab6bd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab6bd96",
  null
  
)

export default component.exports